import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const transferApi = createApi({
  reducerPath: "transferApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_BASE_URL,
    credentials: "include",
  }),
  tagTypes: ["Transfer"],
  endpoints: (builder) => ({
    // ✅ Create new transfer
    addTransfer: builder.mutation({
      query: (newTransfer) => ({
        url: "/transfers/create",
        method: "POST",
        body: newTransfer,
      }),
      invalidatesTags: ["Transfer"],
    }),

    // ✅ Get all transfers (with filters)
    getAllTransfers: builder.query({
      query: ({
        page = 1,
        limit = 10,
        tenantId,
        status,
        fromUserId,
        toUserId,
        search = "",
      } = {}) => {
        const params = { page, limit, tenantId };
        if (status) params.status = status;
        if (fromUserId) params.fromUserId = fromUserId;
        if (toUserId) params.toUserId = toUserId;
        if (search) params.q = search;
        return { url: "/transfers", params };
      },
      providesTags: ["Transfer"],
    }),

    // ✅ Get single transfer by ID
    getTransferById: builder.query({
      query: (id) => ({
        url: `/transfers/${id}`,
        method: "GET",
      }),
      providesTags: (_res, _err, id) => [{ type: "Transfer", id }],
    }),

    // ✅ Get only pending transfers (for receiver)
    getPendingTransfers: builder.query({
      query: ({ tenantId, toUserId }) => ({
        url: "/transfers/status/pending",
        params: { tenantId, toUserId },
      }),
      providesTags: ["Transfer"],
    }),

    // ✅ Respond to transfer (accept/reject)
    respondTransfer: builder.mutation({
      query: (payload) => ({
        url: "/transfers/respond",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Transfer"],
    }),

    // 🗑️ Optional — Delete transfer (if admin)
    deleteTransfer: builder.mutation({
  query: ({ tenantId, transferId, userId, userName, employeeId }) => ({
    url: `/transfers/${transferId}`,
    method: "DELETE",
    body: { tenantId, userId, userName, employeeId },
  }),
  invalidatesTags: ["Transfers", "PendingTransfers"],
}),
  }),
});

export const {
  useAddTransferMutation,
  useGetAllTransfersQuery,
  useGetTransferByIdQuery,
  useGetPendingTransfersQuery,
  useRespondTransferMutation,
  useDeleteTransferMutation, // ✅ add

} = transferApi;

export default transferApi;
